"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AnalyticsProvider_1 = require("../AnalyticsProvider"); //  Map vehicleType enums to vehicleStatus required by Shift Digital as per the Shift implementation guide.


var vehicleStatusMap = {
  New: "New",
  Used: "Used",
  "Certified Used": "CPO"
};
/**
 * For the lack of a better location to document tribal knowledge...
 * Shift changelog
 * 04/2021 - ONSHOP-6504 Shift notices that if you don't interact with inputs on payment builder,
 *      you get neither drPaymentCalcStart nor drPaymentCalcFinish
 *      Concurrent work on ONSHOP-6491 means all Electric deals go through Payment calc, so we decided to simplify
 *      drPaymentCalcStart is sent to Shift when Electric fires paymentBuilderLoad, or Redline fires paymentOptionsLoad
 *      https://dealerinspire.slack.com/archives/G89LE4XM3/p1619039764048500
 *
 *      Shift also announced that a major v2.0 change is coming soon.
 *      The current plan is to *completely rewrite* this provider when the 2.0 spec is available with a stricter emphasis on:
 *      - public FEA methods do not call each other. If several FEA events cause one vendor action,
 *          use private methods like drPaymentCalcStart()
 *      - virtualPageView should not be used to fire discrete events, if you need to act on  "when the customer sees X"
 *          introduce new events like paymentBuilderLoad()
 *
 * 12/2020 - GMCA Shift requested the following changes:
 * 1) Only fire these events once per dealId (session), including leadFormStart, hardPullCreditAppComplete, FAndIFinish and tradeInEstimate.
 * 2) Send in VehicleStatus as a new prop per v1.1 Shift implementation guide.
 * Shift confirmed internally with Ryan Ruiz to keep previous changes as they are.
 * They also confirmed that this can be applied across all OEMs.
 *
 * 03/2020 - Ryan Ruiz from Shift requested specific changes to how we fire events for
 * initialClick, dropSave, calculationStart and calculationFinish.
 */

var ShiftDigitalProvider =
/** @class */
function (_super) {
  __extends(ShiftDigitalProvider, _super);

  function ShiftDigitalProvider(engineConfig, sdConfig) {
    var _this = _super.call(this, "sd") || this;

    _this.loaded = false;
    /**
     * Helper function - Returns object shape required for Shift Digital, maps vehicleType enums
     * to the ones mentioned in Appendix 1 of the Shift implementation guide.
     *
     * Returns a new object where vehicleStatus is mapped to vehicleType and removes vehicleTrim property.
     */

    _this.getShiftDigitalEventObject = function (dealId, vehicle) {
      return {
        dealId: dealId,
        provider: "DealerInspire",
        vehicleMake: vehicle.make,
        vehicleModel: vehicle.model,
        vehicleStatus: vehicleStatusMap[vehicle.type],
        vehicleVin: vehicle.vin,
        vehicleYear: vehicle.year
      };
    };

    _this.engineConfig = engineConfig;
    _this.sdConfig = sdConfig;
    _this.state = {
      calculationStarted: false,
      eventDealIdMap: new Map()
    };

    _this.prepareLocalSD(); // Push config onto the temp queue (q), has to be before any further events (e.g. initialClick)


    _this.sd("create", (_this.sdConfig.oem || "").toUpperCase(), _this.sdConfig.retailerId, _this.sdConfig.providerId);

    _this.loadSD();

    return _this;
  } // Set up a basic queue, in synchronous-time, that events go into.
  // When Shift finally loads in all their dependencies, they drain the queue


  ShiftDigitalProvider.prototype.prepareLocalSD = function () {
    // @ts-ignore
    window.sd = // @ts-ignore
    window.sd || function () {
      // @ts-ignore
      (window.sd.q = window.sd.q || []).push(arguments);
    }; // @ts-ignore


    window.sd.l = 1 * new Date();
  };
  /**
   * TypeScript hates calling methods ShiftDigital hot-patched onto window.
   * Lets centralize all that angst in here.
   */


  ShiftDigitalProvider.prototype.sd = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    } // @ts-ignore


    window.sd.apply(window, __spread(arguments));
  };
  /**
   * Override the Shift object (typically attached to window and private scope by loadSD)
   * especially for mocking in unit tests.
   * @param sd    Typically a Jest Mock Function
   */


  ShiftDigitalProvider.prototype.injectSd = function (sd) {
    this.sd = sd;
  };
  /**
   * Add a <script> element to the page that starts the (laborious) process of
   * loading Shift's whole library, eventually replacing window.sd and draining window.sd.q
   */


  ShiftDigitalProvider.prototype.loadSD = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!this.loaded) return [3
            /*break*/
            , 4];
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , function (i, s, o, g, r, a, m) {
              i["ShiftAnalyticsObject"] = r; // @ts-ignore

              a = s.createElement(o), // @ts-ignore
              m = s.getElementsByTagName(o)[0]; // @ts-ignore

              a.async = 1; // @ts-ignore

              a.src = g; // @ts-ignore

              m.parentNode.insertBefore(a, m);
            }(window, document, "script", this.sdConfig.url, "sd")];

          case 2:
            _a.sent();

            this.loaded = true;
            return [3
            /*break*/
            , 4];

          case 3:
            e_1 = _a.sent();
            console.log("Unable to load Shift Digital library with error: ", e_1);
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Only execute callback once per deal
   * @param event
   * @param dealId
   * @param callback
   */


  ShiftDigitalProvider.prototype.doOncePerDeal = function (event, dealId, callback) {
    if (this.state.eventDealIdMap.has(event) && this.state.eventDealIdMap.get(event) === dealId) {
      return;
    }

    callback();
    this.state.eventDealIdMap.set(event, dealId);
  };

  ShiftDigitalProvider.prototype.initialClick = function (dealId, vehicle) {
    var _this = this;

    this.doOncePerDeal("drInitialClick", dealId, function () {
      var shiftEventObject = _this.getShiftDigitalEventObject(dealId, vehicle);

      if (_this.engineConfig.isRedline) {
        _this.sd("dataLayer", {
          digRet: shiftEventObject,
          events: "drInitialClick",
          pageType: "Digital Retailing"
        });

        _this.sd("send", "pageview");
      } else {
        _this.sd("dataLayer", {
          digRet: shiftEventObject,
          events: "drInitialClick"
        });

        _this.sd("send");
      }

      _this.state.eventDealIdMap.delete("drDropSave");
    });
  };

  ShiftDigitalProvider.prototype.dropSave = function (dealId, vehicle) {
    var _this = this;

    this.doOncePerDeal("drDropSave", dealId, function () {
      var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle); // If the customer abandons, fire drPaymentCalcFinish with NO VEHICLE


      _this.drPaymentCalcFinish(dealId);

      _this.sd("dataLayer", {
        digRet: shiftDigitalObject,
        events: "drDropSave"
      });

      _this.sd("send");

      _this.state.eventDealIdMap.delete("drInitialClick");
    });
  };

  ShiftDigitalProvider.prototype.leadFormStart = function (dealId, vehicle) {
    var _this = this;

    this.doOncePerDeal("drLeadFormStart", dealId, function () {
      var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);

      _this.sd("dataLayer", {
        digRet: shiftDigitalObject,
        events: "drLeadFormStart"
      });

      _this.sd("send");

      _this.state.eventDealIdMap.set("drLeadFormStart", dealId);
    });
  };

  ShiftDigitalProvider.prototype.leadFormFinish = function (dealId, vehicle) {
    var shiftDigitalObject = this.getShiftDigitalEventObject(dealId, vehicle);
    this.sd("dataLayer", {
      digRet: shiftDigitalObject,
      events: "drLeadFormFinish"
    });
    this.sd("send");
    this.state.eventDealIdMap.set("drLeadFormFinish", dealId);
  };

  ShiftDigitalProvider.prototype.appointmentScheduled = function (dealId, vehicle) {
    var shiftDigitalObject = this.getShiftDigitalEventObject(dealId, vehicle);
    this.sd("dataLayer", {
      digRet: shiftDigitalObject,
      events: "drApptSched"
    });
    this.sd("send");
    this.state.eventDealIdMap.set("drApptSched", dealId);
  };

  ShiftDigitalProvider.prototype.tradeInEstimate = function (dealId, vehicle) {
    var _this = this;

    this.doOncePerDeal("drTradeInEval", dealId, function () {
      var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);

      _this.sd("dataLayer", {
        digRet: shiftDigitalObject,
        events: "drTradeInEval"
      });

      _this.sd("send");

      _this.state.eventDealIdMap.set("drTradeInEval", dealId);
    });
  };
  /**
   * Our FEA event paymentOptionsLoad (happens when the customer visits the Redline payment options page)
   * @param dealId
   * @param vehicle
   */


  ShiftDigitalProvider.prototype.paymentOptionsLoad = function (dealId, vehicle) {
    this.drPaymentCalcStart(dealId, vehicle);
  };
  /**
   * Our FEA event paymentBuilderLoad (happens when the customer visits the Electric payment builder page)
   *
   * @param dealId
   * @param vehicle
   */


  ShiftDigitalProvider.prototype.paymentBuilderLoad = function (dealId, vehicle) {
    this.drPaymentCalcStart(dealId, vehicle);
  };
  /**
   * Private method, handles the logic to send-exactly-once Shift's drPaymentCalcStart event
   * @param dealId
   * @param vehicle
   * @private
   */


  ShiftDigitalProvider.prototype.drPaymentCalcStart = function (dealId, vehicle) {
    if (this.dealHasStartedCalculating(dealId)) return;
    var shiftDigitalObject = this.getShiftDigitalEventObject(dealId, vehicle);
    this.sd("dataLayer", {
      digRet: shiftDigitalObject,
      events: "drPaymentCalcStart"
    });
    this.sd("send");
    this.state = __assign(__assign({}, this.state), {
      digRet: shiftDigitalObject,
      calculationStarted: true
    });
    this.state.eventDealIdMap.set("drPaymentCalcStart", dealId);
  };
  /**
   * Our FEA event calculationFinish
   * (happens when the customer completes payment builder, and a few other instances)
   * @param dealId
   * @param vehicle
   */


  ShiftDigitalProvider.prototype.calculationFinish = function (dealId, vehicle) {
    this.drPaymentCalcFinish(dealId, vehicle);
  };
  /**
   * Private method, handles the logic to send-exactly-once Shift's drPaymentCalcFinish event
   * Note: If a customer abandons (is called from dropSave), Shift wants this event to have no vehicle data.
   * If the customer completes the Payment Calc (is called from calculationFinish) Shift wants the event to have that vehicle in digRet.
   * @param dealId
   * @param vehicle
   * @private
   */


  ShiftDigitalProvider.prototype.drPaymentCalcFinish = function (dealId, vehicle) {
    if (!this.dealHasStartedCalculating(dealId)) return;
    var shiftDigitalObject = vehicle ? this.getShiftDigitalEventObject(dealId, vehicle) : {
      dealId: dealId,
      provider: "DealerInspire"
    };
    var finishEvent = {
      digRet: shiftDigitalObject,
      events: "drPaymentCalcFinish"
    };
    this.sd("dataLayer", finishEvent);
    this.sd("send");
    this.resetCalculationState(finishEvent.digRet);
    this.state.eventDealIdMap.set("drPaymentCalcFinish", dealId);
  };

  ShiftDigitalProvider.prototype.FAndIFinish = function (dealId, vehicle) {
    var _this = this;

    this.doOncePerDeal("drFiFinish", dealId, function () {
      var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);

      _this.sd("dataLayer", {
        digRet: shiftDigitalObject,
        events: "drFiFinish"
      });

      _this.sd("send");
    });
  };

  ShiftDigitalProvider.prototype.softPullCreditAppComplete = function (dealId, vehicle) {
    var shiftDigitalObject = this.getShiftDigitalEventObject(dealId, vehicle);
    this.sd("dataLayer", {
      digRet: shiftDigitalObject,
      events: "drPreQ"
    });
    this.sd("send");
    this.state.eventDealIdMap.set("drPreQ", dealId);
  };

  ShiftDigitalProvider.prototype.hardPullCreditAppComplete = function (dealId, vehicle) {
    var _this = this;

    this.doOncePerDeal("drCreditApp", dealId, function () {
      var shiftDigitalObject = _this.getShiftDigitalEventObject(dealId, vehicle);

      _this.sd("dataLayer", {
        digRet: shiftDigitalObject,
        events: "drCreditApp"
      });

      _this.sd("send");
    });
  };
  /**
   * Though reserving a vehicle is a technically separate event,
   * Shift requests we submit the leadFormStart/Finish events.
   *
   * NOTE: This *appears* to fire leadFormStart and leadFormFinish, but in *practice*
   * each of those events only fires once per session, and you have to go past the login form to get to the reservation form,
   * so in *practice* Shift never sees events about the reserve form
   */


  ShiftDigitalProvider.prototype.reserveVehicleFormStart = function (dealId, vehicle) {
    this.leadFormStart(dealId, vehicle);
  };

  ShiftDigitalProvider.prototype.reserveVehicleFormFinish = function (dealId, vehicle) {
    this.leadFormFinish(dealId, vehicle);
  };
  /**
   * Should happen when the user has completed scheduling test-drive appointment with dealer
   * Note: In Shift Docs V2 some more props have been added, so this will eventually be refactored
   * @param  dealId
   * @param  vehicle
   */


  ShiftDigitalProvider.prototype.testDriveFinished = function (dealId, vehicle) {
    var shiftDigitalObject = this.getShiftDigitalEventObject(dealId, vehicle);
    this.sd("dataLayer", {
      digRet: shiftDigitalObject,
      events: "drApptSched"
    });
    this.sd("send");
  };

  ShiftDigitalProvider.prototype.dealHasStartedCalculating = function (newDealId) {
    if (!this.state.calculationStarted || !this.state.digRet) return false;
    return newDealId === this.state.digRet.dealId;
  };

  ShiftDigitalProvider.prototype.resetCalculationState = function (digRet) {
    this.state = __assign(__assign({}, this.state), {
      digRet: digRet,
      calculationStarted: false
    });
  };

  return ShiftDigitalProvider;
}(AnalyticsProvider_1.AnalyticsProvider);

exports.default = ShiftDigitalProvider;